import { useEffect } from 'react';
import XlinkAPI from '~/app/api/xlinkAPI';
import { useSetState } from '~/app/Utility/customHooks';
import { ACCESS_TOKEN } from '~/app/constants';
import { useSelector, useDispatch } from 'react-redux';
import { actions as appActions } from '~/app/redux/modules/app';

const RefreshToken = props => {
  const dispatch = useDispatch();
  const [state, setState] = useSetState({
    previousAccessToken: sessionStorage.getItem(ACCESS_TOKEN), // keep track of the previous access token
  });

  const { refreshTokenExpireTime, isTokenRefreshInProgress } = useSelector(state => ({
    refreshTokenExpireTime: state.app.refreshTokenExpireTime,
    isTokenRefreshInProgress: state.app.isTokenRefreshInProgress,
  }));

  useEffect(() => {
    const intervalId = setInterval(() => {
      const currentTime = Math.floor(new Date().getTime() / 1000);
      // if the token is 60 seconds away from expiring, go ahead and refresh it
      if (refreshTokenExpireTime - currentTime >= 0 && refreshTokenExpireTime - currentTime <= 60) {
        onRefresh();
      }
    }, 15000); // 15000ms = 15 seconds

    // Clean up the interval on unmount
    return () => clearInterval(intervalId);
  }, [refreshTokenExpireTime]);

  useEffect(() => {
    const currentAccessToken = sessionStorage.getItem(ACCESS_TOKEN);

    // if the websockets access token has not been updated due to being closed, send a socket message to update its current access token state with the refreshed token
    if (state.previousAccessToken !== currentAccessToken && currentAccessToken) {
      setState({ previousAccessToken: currentAccessToken });
      props.socketWorker.postMessage(
        JSON.stringify({
          command: 'refreshed_access_token',
          accessToken: currentAccessToken,
        }),
      );
    }
  }, [refreshTokenExpireTime]);

  const onRefresh = async () => {
    // Prevent concurrent refresh requests using Redux state (single-flight pattern)
    if (isTokenRefreshInProgress) return;

    const jwt = sessionStorage.getItem(ACCESS_TOKEN);
    if (!jwt) return;

    dispatch(appActions.setTokenRefreshInProgress(true));
    try {
      await XlinkAPI.validateOrRefresh();
      // Record the timestamp when token refresh completes
      // This is used by CLOIdleTimer to reset the idle timer
      dispatch(appActions.setTokenLastRefreshTime(Math.floor(Date.now() / 1000)));
    } catch (error) {
      console.log('error: ', error);
    } finally {
      dispatch(appActions.setTokenRefreshInProgress(false));
    }
  };

  return null;
};

export default RefreshToken;
